<template>
  <div class="member">
    <h3>企业会员认证及服务费</h3>
    <div class="introduce">
      <div class="title">请选择付费项目</div>
      <div class="fee-type">
        <!-- <div :class="feeType === 1 ? 'active' : ''" @click="feeType = 1">{{yearFee}}元/月</div> -->
        <div :class="feeType === 3 ? 'active' : ''" @click="feeType = 3">{{yearFee2}}元/年</div>
        <!-- <div :class="feeType === 2 ? 'active' : ''" @click="feeType = 2">{{monthFee}}元/三个月</div> -->
      </div>
    </div>
    <div class="pay">
      <div class="choose">请选择支付方式</div>
      <div class="type">
        <div class="alipay" :class="active_index === 1 ? 'active' : ''" @click="active_index = 1">
          <img src="../../assets/img/alipay.png" />
        </div>
        <div :class="active_index === 2 ? 'active' : ''" @click="active_index = 2">境内银行汇款</div>
        <!-- <div :class="active_index === 3 ? 'active' : ''" @click="active_index = 3">境外银行汇款</div> -->
      </div>

      <div class="rights">
        <div class="title">企业认证后的权益：</div>
        <div>
          <span></span>付费企业校企合作沟通更方便顺畅
        </div>
        <div>
          <span></span>付费企业可与学校在线协同管理实习生，在线反馈跟踪确保稳岗在职
        </div>
        <div>
          <span></span>付费企业可第一时间在线获取学校实习就业信息，免去频繁跑学校沟通的麻烦
        </div>
        <div>
          <span></span>付费企业岗位优先推荐给平台近百万应往届毕业生，招人更容易
        </div>
        <!-- <div>
          <span></span>获得10个岗位(岗位有效期一个月）
        </div>
        <div>
          <span></span>招聘岗位在线发布给全校学生，学生随时随地在线应聘
        </div>
        <div>
          <span></span>学校校企合作、校园招聘、毕业生推荐等优先合作推荐
        </div>
        <div>
          <span></span>每年第一时间获取学校招聘通知，免去频繁出差跑学校的麻烦
        </div>
        <div>
          <span></span>应往届毕业生人才全网推荐匹配，节省企业招聘成本
        </div>
        <div>
          <span></span>优先共享推荐校企合作平台全网数百所学校及其学生资源
        </div>
        <div>
          <span></span>平台为您构建企业人力资源储备库，丰富毕业生人才简历资源
        </div>-->
      </div>
      <div style="margin: 20px 0;">
        <div style="margin-bottom: 10px;">温馨提示：</div>
        <!-- <span style="color: red; font-weight: bold;">学生替企业注册的，请直接在APP提交实习申请，无需进行认证缴费！</span> -->
        <div class="zhuyishixiang">1.平台禁止学生替企业注册发布信息，一经发现严肃查处</div>
        <div class="zhuyishixiang">2.企业如有问题，请加客服微信：xiaohezhaopin</div>
        <div class="zhuyishixiang">3.付费后如需发票，请发送开票信息到邮箱:xixun@vanber.cn</div>
      </div>
      <div class="agreement">
        <input type="checkbox" id="agree" />我已阅读并同意
        <a target="_blank" href="/#/agreement-pc">《习讯云校企合作平台信息服务协议》</a>
      </div>
      <div v-if="active_index === 1" class="mt20">
        <el-button v-if="fee !== 0" type="primary" @click="alipay">立即支付</el-button>
        <el-button v-else type="primary" @click="openCooperation">开通校企合作</el-button>
      </div>
      <div class="detail" v-if="active_index === 2">
        <div class="con">
          <div>账号名称</div>
          <div>万博云智（杭州）科技有限公司</div>
        </div>
        <div class="con">
          <div>开户银行</div>
          <div>中国建设银行股份有限公司杭州金沙湖支行</div>
        </div>
        <div class="con">
          <div>银行账号</div>
          <div>3305 0110 2453 0000 0734</div>
        </div>
        <div class="con">
          <div>交易附言</div>
          <div>请备注如下内容：会员认证 + 单位名称</div>
        </div>
        <div class="con">
          <div>提示信息</div>
          <div>截图保存银行转账信息，对公银行转账即可！</div>
        </div>
      </div>
      <div v-if="active_index === 3"></div>
    </div>
    <!-- <div class="btn">立即申请认证</div> -->
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseUrl.js";
import qs from "qs";
import formatter from "@/assets/js/mixins/formatter";

export default {
  mixins: [formatter],
  data() {
    return {
      fee: "",
      active_index: 1,
      pay_subject: this.$route.query.pay_subject || "", // 支付项目：校企合作费、平台服务费
      relation_id: this.$route.query.relation_id || "",
      feeType: 3, // 费用类型
      yearFee: "", // 年费
      yearFee2: "", // 年费
      monthFee: "", // 季费
      payType: "",
      payType2: ""
    };
  },
  mounted() {
    // this.getYearFee();
    this.getYearFee2();
    // this.getMonthFee();
  },
  computed: {
    needFee() {
      if (this.feeType === 1 && this.yearFee !== "0") {
        return true;
      }
      if (this.feeType === 2 && this.monthFee !== "0") {
        return true;
      }
      return false;
    }
  },
  methods: {
    async getYearFee() {
      let schoolId = this.$route.query.school_id;
      let res = await this.$api.pay.getYearFee(schoolId ? schoolId : "0");
      this.yearFee = res.data.fee;
      this.payType = res.data.type;
    },
    async getYearFee2() {
      let params = {
        type: "year",
        school_id: this.$route.query.school_id
      };
      params = this.delNullVal(params);

      let res = await this.$api.pay.getYearFee2(params);
      this.yearFee2 = res.data.fee;
      this.payType2 = res.data.type;
    },
    async getMonthFee() {
      let res = await this.$api.pay.getMonthFee();
      this.monthFee = res.data;
    },
    // 开通校企合作
    async openCooperation() {
      // 是否同意服务协议
      let checked = document.getElementById("agree").checked;
      if (!checked) {
        this.$message.error("请先阅读并同意《习讯云校企合作平台信息服务协议》");
        return;
      }
      let res = await this.$api.pay.openCooperation(this.relationId);
      if (res.code === 0) {
        this.$router.push("/applyList");
      } else {
        this.$message.error(res.msg);
      }
    },
    // 支付宝支付
    async alipay() {
      // 是否同意服务协议
      let checked = document.getElementById("agree").checked;
      if (!checked) {
        this.$message.error("请先阅读并同意《习讯云校企合作平台信息服务协议》");
        return;
      }

      // this.feeType === 1 ? this.payYearFee() : this.payMonthFee();
      if (this.feeType == 3) {
        this.payYearFee2();
      } else {
        if (this.payType === "plat") {
          this.payYearFee();
        } else if (this.payType === "school") {
          this.paySchoolFee();
        } else {
          this.$message.error("无付费类型！");
        }
      }
    },
    payYearFee() {
      let params = {
        subject: "万博云信校企合作服务费",
        type: "web",
        school_id: this.$route.query.school_id
      };
      params = this.delNullVal(params);

      axios
        .post(
          baseUrl + "api/enterprise/pay/platform/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
        });
    },
    payYearFee2() {
      let params = {
        subject: "万博云信校企合作服务费",
        type: "web",
        school_id: this.$route.query.school_id
      };
      params = this.delNullVal(params);

      axios
        .post(
          baseUrl + "api/enterprise/pay/platform_year/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
        });
    },
    async paySchoolFee() {
      let params = {
        subject: "校企合作认证年费",
        type: "web",
        relation_id: this.$route.query.relation_id
      };

      axios
        .post(
          baseUrl + "api/enterprise/pay/school/alipay/index",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
        });
    },
    payMonthFee() {
      let params = {
        subject: "万博云信校企合作服务费（季度）",
        type: "web"
      };
      axios
        .post(
          baseUrl + "api/enterprise/pay/platform/alipay/quarter",
          qs.stringify(params),
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.data.code && res.data.code !== 0) {
            this.$message.error(res.data.msg);
            return;
          }
          const div = document.createElement("div");
          div.innerHTML = res.data;
          document.body.appendChild(div);
          document.forms[0].acceptCharset = "GBK"; //保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
          document.forms[0].submit();
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/base.scss";

.member {
  width: 700px;
  margin: 20px auto 0;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px 50px;
  h3 {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    color: #333;
  }
  .introduce {
    margin: 20px 0 0;
    padding: 20px 0 20px 20px;
    border-top: 2px solid #999;
    border-bottom: 2px solid #999;
    .fee-type {
      display: flex;
      margin: 20px 0 0;
      div {
        padding: 10px 20px;
        margin: 0 20px 0 0;
        border: 1px solid #999;
        border-radius: 5px;
      }
      div.active {
        color: $blue;
        border-color: $blue;
      }
    }
  }
  .pay {
    padding: 20px 0 0 20px;
    .type {
      margin: 20px 0 0;
      display: flex;
      div {
        padding: 10px 20px;
        margin: 0 5px 0 0;
        border: 1px solid #999;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .alipay {
        img {
          width: 80px;
        }
      }
      .active {
        border-color: $blue;
        color: $blue;
      }
    }
    .rights {
      margin: 20px 0 0;
      line-height: 1.5;
      .title {
        margin: 0 0 10px 0;
        font-weight: bold;
      }
      div span {
        display: inline-block;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #4b7ff7;
        margin-right: 10px;
      }
    }
    .detail {
      display: flex;
      flex-direction: column;
      border: 1px solid #999;
      border-radius: 5px;
      margin: 20px 0 0;
      padding: 10px;
      .con {
        display: flex;
        margin: 0 0 10px;
        color: #a65b32;
        div:nth-child(1) {
          width: 100px;
          text-align: right;
          margin-right: 10px;
          font-weight: bold;
        }
      }
    }
    .zhuyishixiang{
      color: red;
      font-size: 16px;
      margin: 8px 30px;
    }
  }
  .btn {
    width: 200px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
    background: $blue;
    color: #fff;
    margin: 30px auto 0;
  }
}
</style>